
export enum SelectParent_RenderType {
    FORM            = 'form',           // standard form element 36 px
    INLINE_EDITABLE = 'inline-editable',
    CIRCLE_BTN      = 'circle-btn-28',
    FUNCTION        = 'function',
    GRAY_RECTANGLE  = 'gray-rectangle',
    CONTROL_BUTTON  = 'control-button',
    // VIEW            = 'view',
}


export enum AttachmentType {
    FULL        = "full",
    VERTICAL    = "vertical",
    HORIZONTAL  = "horizontal",
}

export enum SelectParent_SectionType {
    PROJECTS    = "projects",
    STARRED     = "starred",
    PINNED      = "pinned",
    SEARCH      = "search",

}

export enum ExpandedStatus {
    ALL_COLLAPSED   = 0,
    ALL_EXPANDED    = 1,
    NOT_ALL         = 2,
}
